import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Magnifer from '@/images/Magnifer.svg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';

const Banner = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;

    transform: translate(0, -50%);

    padding: 40px 72px;
    max-width: 625px;
    border-radius: 20px;
    background: #fff;
    align-items: center;
    justify-content: center;
    text-align: center;

    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.48px;
`;

export const NotFoundBanner = () => {
    const theme = useTheme();

    return (
        <Banner>
            <Content>
                <MaskedIcon src={Magnifer} size="52px" color={theme.colors.black[500]} />
                Sorry, we didn’t find Avatars for your search
            </Content>
        </Banner>
    );
};
